import { NavLink, useLocation } from "react-router-dom";

const TABS = [
  { to: "/", label: "الرئيسية", icon: "🏠", testId: "nav-home" },
  { to: "/tracks", label: "المسارات", icon: "🗺️", testId: "nav-tracks" },
  { to: "/chat", label: "المعلّم", icon: "💬", testId: "nav-chat" },
  { to: "/challenges", label: "التحدّيات", icon: "🏆", testId: "nav-challenges" },
  { to: "/profile", label: "الملفّ", icon: "👤", testId: "nav-profile" },
];

const NAV_HIDDEN_ROUTES = ["/login", "/auth/callback"];

export default function BottomNav() {
  const loc = useLocation();
  if (NAV_HIDDEN_ROUTES.includes(loc.pathname)) return null;
  // Hide inside a lesson (keeps lesson immersive)
  if (loc.pathname.startsWith("/lesson/")) return null;

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <div className="bottom-nav-inner">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === "/"}
            className={({ isActive }) =>
              "tab" + (isActive ? " active" : "")
            }
            data-testid={t.testId}
          >
            <span className="tab-icon">{t.icon}</span>
            <span className="tab-label">{t.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
